import React, { useEffect, useState } from "react";
import InnerLayout from "../../components/layouts/inner-layout";
import AdminCusCreateEditView from "../../components/admin-customer/admin-cus-create-edit-view";
import { useDispatch } from "react-redux";
import { adminCustomerViewAction } from "../../redux/actions/admin-customer-action";
import AdminCusCreateEditViewn from "../../components/admin-customer/admin-cus-create-edit-viewn";
import moment from "moment";

const AdminAddCustomern = () => {
  const [reload, setReload] = useState(false);
  const [customerId, setCustomerId] = useState(null);
  const dispatch = useDispatch();
  const [customerDetails, setCustomerDetails] = useState({});

  // useEffect(() => { 
  //   if (customerId) {
  //     dispatch(adminCustomerViewAction(customerId, onSuccess, onError));
  //   }
  // }, [customerId, reload]);

  // const onSuccess = (data) => {
  //   console.log(data, "customer Details");
  //   setCustomerDetails(data?.data);
  // };
  // const onError = (data) => {
  //   console.log(data);
  // };

  useEffect(() => {
    // const existingData = JSON.parse(localStorage.getItem("customerAdmin"));
    // let cmrId = existingData?.customerId;
    // console.log("cmrid", cmrId);
    // if (cmrId) {
    //   setCustomerId(cmrId);
    //   // setGeneralCreated(true);
    // }
    localStorage.removeItem("customerAdmin");
  }, []);
  const initialData = {
    customerId: null,
    addressPay: [
      {
        // cmr_pay_address_id: "",
        // cmr_id: "",
        cmr_pay_address_name: "",
        cmr_pay_address_country: "",
        cmr_pay_address_state: "",
        cmr_pay_address_district: "",
        cmr_pay_address_city: "",
        cmr_pay_address_town: "",
        cmr_pay_address_street: "",
        cmr_pay_address_pincode: "",
        cmr_pay_address_address: "",
        cmr_default_address: true,
      },
    ],
    addressShipping: [
      {
        // cmr_ship_address_id: "",
        // cmr_id: "",
        cmr_ship_address_name: "",
        cmr_ship_address_country: "",
        cmr_ship_address_state: "",
        cmr_ship_address_district: "",
        cmr_ship_address_city: "",
        cmr_ship_address_town: "",
        cmr_ship_address_street: "",
        cmr_ship_address_pincode: "",
        cmr_ship_address_address: "",
        cmr_default_address: true,
      },
    ],
    contacts: [
      {
        // cmr_contact_person_id: "",
        // cmr_id: "",
        contact_person_name: "",
        contact_person_phone: "",
        contact_person_email: "",
        contact_person_country: "",
        contact_person_state: "",
        contact_person_district: "",
        contact_person_city: "",
        contact_person_pincode: "",
        contact_address: "",
        cmr_default_contact_persons: true,
      },
    ],
    family: [
      {
        // cmr_id: "",
        // cmr_family_id: "",
        cmr_full_name: "",
        cmr_relationship: "",
        cmr_dob: "",
        cmr_phone_number: "",
        cmr_email: "",
        cmr_address: "",
        cmr_remarks: "",
        cmr_is_default: true,
      },
    ],
    banking: [
      {
        // cmr_bank_id: "",
        // cmr_id: "",
        cmr_bank_name: "",
        cmr_account_no: "",
        cmr_ifsc_code: "",
        cmr_bank_branch: "",
        cmr_default_bank_details: true,
      },
    ],
    payment: {
      // cmr_id: "",
      cmr_payment_terms: "",
      cmr_interest_on_arreas_percentage: 0,
      cmr_total_discount_percentage: 0,
      cmr_credit_limit: 0,
      cmr_commitment_limit: 0,
      cmr_effective_price: 0,
      cmr_price_list: "",
      cmr_discount_group: "",
      cmr_payment_percentage: 0,
    },
    general: {
      cmr_first_name: "",
      cmr_last_name: "",
      // cmr_store_mapping: "",
      cmr_type: "individual",
      cmr_dob: "",
      cmr_phone_number: "",
      cmr_email: "",
      cmr_active_status: true,
      cmr_active_from: null,
      cmr_inactive_from: null,
      cmr_remarks: "",
      cmr_acquired_source: "",
      cmr_balance: 0,
      cmr_currency: null,
      cmr_payment_terms: "",
      cmr_shipping_method: "",
      is_ecommerce_cmr: false,
      is_vendor_cmr: false,
      is_corporate_cmr: false,
      is_store_cmr: false,
      update_sign: null,
      cmr_country: "",
      cmr_state: "",
      cmr_district: "",
      cmr_city: "",
      cmr_town: "",
      cmr_village: "",
      cmr_street1: "",
      cmr_street2: "",
      cmr_pincode: "",
      cmr_address: "",
      cmr_company: "",

      cmr_pan: "",
      cmr_sector: "",
      cmr_tax: "",
      cmr_business_type: "",
      cmr_gstin: "",
      cmr_group_id: "",
      inter_company_sync: false,
      cmr_tcs: "",
      cmr_tds: "",
      store_id: "",
      cmr_fssai: "",
      cmr_dl_no: "",
      cmr_gstin_certificate: "",
      cmr_dl_certificate: "",
      cmr_fssai_certificate: "",
      cmr_latitude: "",
      cmr_longitude: "",
      cmr_party_category: "",
    },
    patient: {
      cmr_id: "",
      cmr_name: "",
      cmr_gender: "",
      cmr_abha_number: "",
      cmr_blood_group: "",
      cmr_dob: "",
      cmr_weight: 0,
      cmr_height: 0,
      cmr_primary_doctor: "",
      cmr_id_proof_type: "",
      cmr_id_proof_number: "",
      cmr_medical_history: "",
      cmr_allergies: "",
      cmr_current_medications: "",
      cmr_emergency_contact_name: "",
      cmr_emergency_contact_phone: "",
      // cmr_patient_type: "",
      cmr_payment_terms: "",
    },
    insurance: [
      {
        // Unique family member ID (ulid or uuid)
        // cmr_id: "",
        cmr_policy_holder_name: "",
        // cmr_policy_number: "",
        cmr_insurance_provider: "",
        cmr_policy_period_from: "",
        cmr_policy_period_to: "",
        cmr_premium_amount: 0,
        cmr_contact_person: "",
        cmr_coverage_details: "",
        cmr_claim_history: "",
      },
    ],
  };
  return (
    <InnerLayout
      //   onclkFn={"/admin/add-customer"}
      title="Create Party"
      backBtn={true}
    >
      <AdminCusCreateEditViewn
        cmrId={customerId}
        setCustomerId={setCustomerId}
        reload={reload}
        setReload={setReload}
        customerDetails={customerDetails}
        initialData={initialData}
        page="add"
        disabled={false}
      />
    </InnerLayout>
  );
};

export default AdminAddCustomern;
